import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SocketProvider } from "./context/SocketContext";
import { ThemeProvider } from "./context/ThemeContext";
import Login from "./pages/Login";
import VueEnsemble from "./pages/VueEnsemble";
import Revendeurs from "./pages/Revendeurs";
import Clients from "./pages/Clients";
import Chantiers from "./pages/Chantiers";
import Noeuds from "./pages/Noeuds";
import Automatisations from "./pages/Automatisations";
import Equipe from "./pages/Equipe";
import CreerAutomatisation from "./pages/CreerAutomatisation";
import Projets from "./pages/Projets";
import Evenements from "./pages/Evenements";
import CreerEvenement from "./pages/CreerEvenement";
import Abonnements from "./pages/Abonnements";
import Fonctions from "./pages/Fonctions";
import CreerFonction from "./pages/CreerFonction";
import Alertes from "./pages/Alertes";
import Journal from "./pages/Journal";
import Parametres from "./pages/Parametres";
import Users from "./pages/Users";
import Invitation from "./pages/Invitation";
import Simulateur from "./pages/Simulateur";
import ProjetDetail from "./pages/ProjetDetail";
import ChantierDetail from "./pages/ChantierDetail";
import Layout from "./components/layout/Layout";

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-500 dark:text-slate-400 text-sm">Chargement...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/invitation" element={<Invitation />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<VueEnsemble />} />
        <Route path="/revendeurs" element={<Revendeurs />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/projets" element={<Projets />} />
        <Route path="/projets/:id" element={<ProjetDetail />} />
        <Route path="/chantiers" element={<Chantiers />} />
        <Route path="/chantiers/:id" element={<ChantierDetail />} />
        <Route path="/noeuds" element={<Noeuds />} />
        <Route path="/equipe" element={<Equipe />} />
        <Route path="/evenements" element={<Evenements />} />
        <Route path="/evenements/creer" element={<CreerEvenement />} />
        <Route path="/automatisations" element={<Automatisations />} />
        <Route path="/fonctions" element={<Fonctions />} />
        <Route path="/fonctions/creer" element={<CreerFonction />} />
        <Route path="/automatisations/creer" element={<CreerAutomatisation />} />
        <Route path="/automatisations/edit/:id" element={<CreerAutomatisation />} />
        <Route path="/abonnements" element={<Abonnements />} />
        <Route path="/alertes" element={<Alertes />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/utilisateurs" element={<Users />} />
        <Route path="/simulateur" element={<Simulateur />} />
        <Route path="/parametres" element={<Parametres />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <SocketProvider>
            <AppRoutes />
          </SocketProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
